import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-checkbox",
  "use": "icon-checkbox-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-checkbox\">\n<rect width=\"24\" height=\"24\" rx=\"12\" fill=\"#0052CC\" />\n<rect x=\"4\" y=\"4\" width=\"16\" height=\"16\" rx=\"4\" fill=\"#0052CC\" />\n<path d=\"M8 12L11 15L16 10\" stroke=\"white\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol